var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "filter-container" },
      [
        _c(
          "el-button",
          {
            staticClass: "filter-item",
            attrs: { type: "success", icon: "el-icon-back" },
            on: { click: _vm.returnFun }
          },
          [_vm._v("返回")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "filter-item",
            attrs: { type: "primary", icon: "el-icon-plus" },
            on: { click: _vm.addFun }
          },
          [_vm._v("新增")]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.title,
              visible: _vm.newadd,
              width: "500px",
              "before-close": _vm.closeRefund,
              center: ""
            },
            on: {
              "update:visible": function($event) {
                _vm.newadd = $event
              }
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "addForm",
                staticClass: "mark",
                attrs: {
                  model: _vm.addData,
                  rules: _vm.rules,
                  "label-width": "160px"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "指令Id", prop: "programId" } },
                  [
                    _c("el-input", {
                      attrs: { type: "text", readonly: "" },
                      model: {
                        value: _vm.addData.programId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "programId", $$v)
                        },
                        expression: "addData.programId"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "语言类型", prop: "languageId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "请选择" },
                        model: {
                          value: _vm.addData.languageId,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "languageId", $$v)
                          },
                          expression: "addData.languageId"
                        }
                      },
                      _vm._l(_vm.languageList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.type, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "翻译-名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.addData.name,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "name", $$v)
                        },
                        expression: "addData.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "翻译-说明", prop: "remarks" } },
                  [
                    _c("el-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.addData.remarks,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "remarks", $$v)
                        },
                        expression: "addData.remarks"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.title == "新增"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("提交")]
                        ),
                        _vm._v(" "),
                        _c("el-button", { on: { click: _vm.onCencal } }, [
                          _vm._v("取消")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.title == "编辑"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.onUpdate }
                          },
                          [_vm._v("提交")]
                        ),
                        _vm._v(" "),
                        _c("el-button", { on: { click: _vm.onCencal } }, [
                          _vm._v("取消")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            attrs: {
              data: _vm.tableData,
              border: "",
              stripe: "",
              "cell-style": _vm.isCenter,
              "header-cell-style": _vm.isCenter,
              "highlight-current-row": ""
            }
          },
          [
            _c("el-table-column", {
              attrs: { type: "index", width: "45", label: "序号" }
            }),
            _vm._v(" "),
            _vm._l(_vm.tableColumns, function(column, index) {
              return [
                column.isShow
                  ? _c("el-table-column", {
                      key: index,
                      attrs: {
                        prop: column.prop,
                        label: column.label,
                        formatter: column.formatter,
                        width: column.width,
                        sortable: column.sortable
                      }
                    })
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作", "min-width": "160", prop: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            title: "编辑",
                            size: "mini"
                          },
                          on: {
                            click: function($event) {
                              return _vm.updateMenu(scope.row)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            title: "删除",
                            size: "mini"
                          },
                          on: {
                            click: function($event) {
                              return _vm.delMenu(scope.row)
                            }
                          }
                        },
                        [_vm._v("删除")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.pageData.total > 0,
                  expression: "pageData.total>0"
                }
              ],
              attrs: {
                "current-page": _vm.pageData.page,
                "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
                "page-size": _vm.pageData.rows,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.pageData.total
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }